@if ((corporateTaxEntity$ | async)) {
  <form (change)="this.saveForm()" [formGroup]="ontbindingFg">
    <div formArrayName="ontbinding">
      @for (item of ontbinding.controls; track item; let i = $index) {
        <div class="row mb-1">
          <div class="col-auto">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Naam ontbonden dochter' : ''"
                                            [required]=true
                                            class="custom-input-250"
                                            formControlName="naamDochter"
                                            id="naamDochter"
            >
            </snelstart-ui-text-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-date-form-control [label]="i === 0 ? 'Datum ontbinding' : ''"
                                            [required]=true
                                            class="custom-input-150"
                                            formControlName="ontbindingsdatum"
                                            id="ontbindingsdatum"
                                            placeholder="dd-mm-jjjj"
            >
            </snelstart-ui-date-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control [label]="i === 0 ? 'Onbetaalde schuld' : ''"
                                              [required]=true
                                              [showAllDecimals]="false"
                                              align="right" class="custom-input-150"
                                              formControlName="onbetaaldGeblevenSchulden"
                                              id="onbetaaldGeblevenSchulden"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="cancel"
                       type="link">Vennootschap toevoegen
  </snelstart-ui-button>
}
